const PlayerEvents = [
    'playerCreated',
    'playerDestroyed',
    '_playerTimeUpdate',
    'playerTimeUpdate',
    'playerPlay',
    'playerPlaying',
    'playerFirstPlay',
    'playerReplay',
    'playerPause',
    '_playerSeek',
    'playerSeek',
    'playerSeeking',
    'playerNudge',
    'playerEnd',
    'playerError',
    'playerVolumeChange',
    'playerFullscreen',
    'playerSwitchBitrate',
    'playerAutoSwitchBitrate',
    'playerProgress',
    'playerLoadedMetadata',
    'playerDurationChange',
    'playerBuffering',
    'playerBufferedEnough',
];

export default PlayerEvents;



// WEBPACK FOOTER //
// ./src/js/events/player-events.js